import { useState } from "react";
import { cn } from "@/lib/utils";
import { mediaUrl } from "@/lib/media";

// Group/club logo with a 🏆 fallback. Routes the stored URL through the
// /api/media proxy (so it loads regardless of S3 bucket ACL) and falls
// back to the trophy tile on a missing/broken image instead of showing
// the browser's broken-image icon.
export function GroupLogo({
  url,
  size = 36,
  rounded = "md",
  className,
  emojiClassName,
}: {
  url?: string | null;
  size?: number;
  rounded?: "md" | "lg" | "full";
  className?: string;
  emojiClassName?: string;
}) {
  const src = mediaUrl(url);
  const [broken, setBroken] = useState(false);
  const radius = rounded === "full" ? "rounded-full" : rounded === "lg" ? "rounded-lg" : "rounded-md";
  const style = { width: size, height: size };

  if (src && !broken) {
    return (
      <img
        src={src}
        alt=""
        style={style}
        loading="lazy"
        onError={() => setBroken(true)}
        className={cn(radius, "object-cover shrink-0", className)}
      />
    );
  }
  return (
    <div
      style={{ ...style, fontSize: Math.round(size * 0.5) }}
      className={cn(radius, "bg-muted flex items-center justify-center shrink-0 leading-none", className, emojiClassName)}
    >
      🏆
    </div>
  );
}
